import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fddcf576"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "icon-box"
};
const _hoisted_2 = { class: "expand-icon-box" };
const _hoisted_3 = { class: "menu-box" };
const _hoisted_4 = {
    key: 0,
    class: "menu-header"
};
const _hoisted_5 = {
    key: 1,
    class: "menu-header"
};
const _hoisted_6 = {
    key: 0,
    class: "text"
};
import { useRouterGroup } from "@/hooks/useRouterGroup";
import { appCounterStore } from "@/store/app";
import { permissionStore } from "@/store/permission";
import { computed, ref, unref } from "vue";
import { useRoute } from "vue-router";
import SidebarItem from "./SidebarItem.vue";
import { replaceUrl } from "@/utils";
import personal from "./personal.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    setup(__props) {
        const store = permissionStore();
        const route = useRoute();
        const appStore = appCounterStore();
        const logo = computed(() => {
            return appStore.sidebar
                ? { name: "logo", class: "logo-style" }
                : { name: "logo1", class: "logo1-style" };
        });
        const goPortal = () => {
            window.open(replaceUrl(window.location.origin, "www"));
        };
        const iconClass = ref("left");
        const iconState = ref(false);
        const { activeRouterName, routeList } = useRouterGroup();
        const permission_routes = computed(() => {
            const routerList = store.getRoutes;
            const obj = JSON.parse(JSON.stringify(routeList));
            for (let key in obj) {
                obj[key].value = obj[key]["includeModel"].map((value) => {
                    const result = routerList.filter((item) => {
                        return value.includes(item.name);
                    });
                    return result;
                });
            }
            return obj;
        });
        const sidebar = computed(() => appStore.sidebar);
        const activeMenu = computed(() => {
            const { meta, path } = route;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        });
        const foldState = computed(() => unref(appStore.getSidebar));
        const foldHandel = () => {
            if (foldState.value) {
                iconClass.value = "left";
                appStore.setSidebar(false);
            }
            else {
                iconClass.value = "right";
                appStore.setSidebar(true);
            }
        };
        const mouseenter = () => {
            iconState.value = true;
        };
        const mouseleave = () => {
            iconState.value = false;
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_menu = _resolveComponent("el-menu");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["sidebar-layout", { expand: _unref(sidebar) }])
            }, [
                _createElementVNode("div", {
                    class: "login-img",
                    onClick: goPortal
                }, [
                    _createVNode(_component_svg_icon, {
                        "icon-class": _unref(logo).name,
                        class: _normalizeClass(_unref(logo).class)
                    }, null, 8, ["icon-class", "class"])
                ]),
                _createElementVNode("div", {
                    class: "expand-box",
                    onClick: foldHandel,
                    onMouseenter: mouseenter,
                    onMouseleave: mouseleave
                }, [
                    (!iconState.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                        : (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 1,
                            class: "box-item",
                            effect: "dark",
                            content: _unref(sidebar) ? '展开' : '收起',
                            placement: "right",
                            "popper-class": "my-tooltip-popper"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_svg_icon, {
                                        "icon-class": 'expand-' + (_unref(sidebar) ? 'off' : 'on'),
                                        class: "expand-icon"
                                    }, null, 8, ["icon-class"])
                                ])
                            ]),
                            _: 1
                        }, 8, ["content"]))
                ], 32),
                _createElementVNode("div", _hoisted_3, [
                    (_unref(activeRouterName) === 'finance' && !_unref(sidebar))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 费用中心 "))
                        : _createCommentVNode("", true),
                    (_unref(activeRouterName) === 'setting' && !_unref(sidebar))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 访问控制 "))
                        : _createCommentVNode("", true),
                    _createVNode(_component_el_menu, {
                        "collapse-transition": false,
                        "default-active": _unref(activeMenu),
                        "background-color": "transparent",
                        collapse: _unref(sidebar),
                        class: "menu"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(permission_routes), (route, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (route.label)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(["moudule-box", { 'h-34': _unref(sidebar) }])
                                        }, [
                                            (!_unref(sidebar))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(route.label), 1))
                                                : _createCommentVNode("", true),
                                            (route.value.length)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: _normalizeClass(["line", { expand_line: _unref(sidebar) }])
                                                }, null, 2))
                                                : _createCommentVNode("", true)
                                        ], 2))
                                        : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.value[0], (permission_route) => {
                                        return (_openBlock(), _createBlock(SidebarItem, {
                                            key: permission_route.path,
                                            "active-menu": _unref(activeMenu),
                                            item: permission_route,
                                            "base-path": permission_route.path
                                        }, null, 8, ["active-menu", "item", "base-path"]));
                                    }), 128))
                                ], 64));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["default-active", "collapse"])
                ]),
                _createVNode(personal)
            ], 2));
        };
    }
});
